module.exports = __webpack_public_path__ + "media/assets/images/tour/4a_Tour_5-960432ea0be692e2dba2c49ba9174827.png";